import api from "./axiosInstance";

export const getOrders = async (limit = 10, offset = 0) => {
  const res = await api.get(`api/v1/orders/?limit=${limit}&offset=${offset}`);
  return res.data;
};

export const getOrderById = async (id) => {
  const res = await api.get(`api/v1/orders/${id}/`);
  return res.data;
};
